/*
  VIETTI — lanciatore custom della live chat Gorgias (issue #444).

  Base documentale (riletta il 14/09/2026 su docs.gorgias.com):
  - «Customize the chat widget with HTML and JavaScript» (art. 286032):
    oggetto window.GorgiasChat, wrapper di init (GorgiasChat.init() oppure
    attesa dell'evento window 'gorgias-widget-loaded'), collocazione del
    codice custom DOPO lo snippet di installazione, dentro <body>.
  - «HTML snippets for chat customization» (art. 460197): snippet «Replace
    the chat widget button with a custom element» (nasconde l'iframe
    #chat-button dentro #gorgias-chat-container quando la sua <head> è
    popolata e inserisce un bottone proprio che apre/chiude con
    GorgiasChat.open()/close()); eventi GorgiasChat.on('widget:opened' |
    'widget:closed' | 'unreadCount'); GorgiasChat.disableSegment() «to
    comply with privacy requirements», da chiamare per primo.

  Comportamento:
  1) GorgiasChat.disableSegment() come prima chiamata (niente analytics
     Segment del fornitore: la chat serve al servizio clienti, non alla
     misurazione);
  2) lanciatore nativo nascosto e sostituito dal bottone «Live chat»
     (testo vero nel DOM, stile in gorgias-widget.css, etichetta identica
     IT/EN come deciso per il lanciatore Klaviyo, #291 §7.2; testi da
     locales via window.viettiChatStrings, impostati dallo snippet
     gorgias-chat.liquid);
  3) badge «messaggi non letti» sul bottone custom dall'evento unreadCount
     (colma il limite dichiarato nella versione dell'08/09);
  4) apertura/chiusura seguono gli eventi ufficiali widget:opened /
     widget:closed (anche quando il visitatore chiude con la X interna).

  Fail-safe: se questo script non parte o si rompe, il lanciatore nativo di
  Gorgias resta visibile e la chat funziona con l'aspetto di default: il
  nativo viene nascosto SOLO dopo che il bottone custom è in pagina.

  Consenso: questo file NON gestisce il consenso. Il gate
  (assets/gorgias-consent-gate.js, fail-closed) decide se il loader Gorgias
  parte; se non parte, l'evento 'gorgias-widget-loaded' non arriva mai e qui
  non succede nulla (zero richieste, zero DOM).
*/
(function () {
  'use strict';

  var strings = window.viettiChatStrings || {};
  var LABEL = strings.launcherLabel || 'Live chat';
  var ARIA_LABEL = strings.launcherAria || LABEL;
  var UNREAD_TEMPLATE = strings.unread || '[count]';
  var POLL_MS = 100;
  var POLL_MAX = 150; /* 15 s, poi ci si arrende senza effetti visibili */
  var INJECT_WINDOW_CSS = false; /* blocco 5, facoltativo e fragile: OFF al collaudo */

  /* Wrapper di init ufficiale (art. 286032): copre sia il widget già
     presente sia il widget che arriva dopo questo script. */
  function whenChatReady(callback) {
    var ready = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve();
          });
        });
    ready.then(callback);
  }

  whenChatReady(function () {
    var chat = window.GorgiasChat;
    if (!chat) return;

    /* 1) Privacy: niente Segment (doc 460197, «Disable Segment tracking»). */
    try {
      if (typeof chat.disableSegment === 'function') chat.disableSegment();
    } catch (e) { /* metodo assente in questa versione: si prosegue */ }

    /* 2) Bottone custom (testo vero nel DOM, accessibile). */
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vietti-chat-launcher';
    button.setAttribute('aria-label', ARIA_LABEL);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'vietti-chat-launcher__label';
    label.textContent = LABEL;
    button.appendChild(label);

    var badge = document.createElement('span');
    badge.className = 'vietti-chat-launcher__badge';
    badge.hidden = true;
    button.appendChild(badge);

    function setOpenState(isOpen) {
      button.classList.toggle('vietti-chat-launcher--hidden', isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function setUnread(count) {
      var n = parseInt(count, 10) || 0;
      if (n > 0) {
        badge.textContent = String(n);
        badge.hidden = false;
        button.setAttribute('aria-label', ARIA_LABEL + '. ' + UNREAD_TEMPLATE.replace('[count]', String(n)));
      } else {
        badge.hidden = true;
        button.setAttribute('aria-label', ARIA_LABEL);
      }
    }

    button.addEventListener('click', function () {
      if (!window.GorgiasChat) return;
      if (window.GorgiasChat.isOpen()) {
        window.GorgiasChat.close();
        setOpenState(false);
      } else {
        window.GorgiasChat.open();
        setOpenState(true);
        setUnread(0);
      }
    });

    /* 3) Sostituzione del lanciatore nativo — snippet ufficiale art. 460197:
       si attende che la <head> dell'iframe #chat-button sia popolata, poi
       si nasconde l'iframe e si inserisce il bottone nostro. Ordine
       fail-safe: prima il bottone in pagina, poi il nativo nascosto. */
    var tries = 0;
    var poll = setInterval(function () {
      var container = document.querySelector('#gorgias-chat-container');
      var nativeButton = container && container.querySelector('#chat-button');
      var head = null;
      try {
        head = nativeButton && nativeButton.contentWindow &&
          nativeButton.contentWindow.document.querySelector('head');
      } catch (e) { head = null; }
      if (nativeButton && head && head.children.length) {
        clearInterval(poll);
        document.body.appendChild(button);
        nativeButton.style.display = 'none';
      } else if (++tries > POLL_MAX) {
        clearInterval(poll); /* nativo non trovato: resta il lanciatore Gorgias di default */
      }
    }, POLL_MS);

    /* 4) Eventi ufficiali (doc 460197 «Subscribing to chat events»). */
    if (typeof chat.on === 'function') {
      chat.on('widget:opened', function () { setOpenState(true); setUnread(0); });
      chat.on('widget:closed', function () { setOpenState(false); });
      chat.on('unreadCount', function (count) {
        if (!(window.GorgiasChat && window.GorgiasChat.isOpen())) setUnread(count);
      });
      if (INJECT_WINDOW_CSS) chat.on('widget:opened', injectChatWindowCss);
    }
  });

  /* 5) FACOLTATIVO (OFF) — CSS dentro la finestra chat (angoli vivi),
     pattern ufficiale «Add custom CSS to the chat window» (art. 460197):
     <style> nella head dell'iframe #chat-window dopo widget:opened. La doc
     avverte che i selettori interni non sono stabili: rottura solo
     estetica. Si accende con INJECT_WINDOW_CSS = true dopo il collaudo. */
  var chatCssInjected = false;
  function injectChatWindowCss() {
    if (chatCssInjected) return;
    var tries = 0;
    var poll = setInterval(function () {
      var container = document.querySelector('#gorgias-chat-container');
      var chatWindow = container && container.querySelector('#chat-window');
      var head = null;
      try {
        head = chatWindow && chatWindow.contentWindow &&
          chatWindow.contentWindow.document.querySelector('head');
      } catch (e) { head = null; }
      if (head && head.children.length) {
        var chatStyle = document.createElement('style');
        chatStyle.textContent = '* { border-radius: 0 !important; }';
        head.appendChild(chatStyle);
        chatCssInjected = true;
        clearInterval(poll);
      } else if (++tries > POLL_MAX) {
        clearInterval(poll);
      }
    }, 50);
  }
})();
